import {useHistory, useLocation} from "react-router";

import {parseSearch} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {createOfferLink} from "../../offer/helpers/create_offer_link";
import {OfferListSubType} from "../../offer/list/types/OfferListSubType";
import {useUserPreferences} from "../../user/hooks/use_user_preferences";
import {ILatestQuery} from "../../utils/latest_query";
import {SearchTab} from "../actions/fetch_search_all_action";
import {gtmSearch} from "../analytics/events";
import {ISearchInputValue} from "../components/ISearchInputValue";
import {SearchFormValuesType} from "../types/SearchFormValuesType";
import {getSearchTerm} from "../utils/get_search_term";
import {getSearchUrlWithFilters} from "../utils/get_search_url_with_filters";
import {useSearchGtm} from "./use_search_gtm";

export interface IHookParams {
    multiRegionLink: () => string;
    latestQuery: ILatestQuery;
    listFriendlyLink: (params: {friendlySlug: string; offerListSubFilterSlug?: string}) => string;
    abroadListFriendlyLink: (params: {friendlySlug: string; country: string; abroadRegionSlug?: string}) => string;
    onAfterSubmit?: () => void;
    offerListSubType?: OfferListSubType;
}

// Logic moved from apps/rp/src/common/search/components/Search.tsx
export function useSearchFormSubmit(params: IHookParams) {
    const {multiRegionLink, latestQuery, listFriendlyLink, abroadListFriendlyLink, onAfterSubmit} = params;
    const {gtmLabel, gtmCategory} = useSearchGtm();

    const location = useLocation();
    const history = useHistory();

    const {saveUserPreferences} = useUserPreferences();

    return async (formValues: SearchFormValuesType) => {
        const searchValue = formValues["search"] as ISearchInputValue;
        const searchTerm = getSearchTerm(searchValue);

        gtmSearch(searchTerm, gtmCategory, gtmLabel);

        if (searchValue.tabType === SearchTab.Offers) {
            return (window.location.href = createOfferLink({
                ...searchValue.offer,
                vendor: searchValue.vendor,
                groups: searchValue.offer.groups
            }));
        }

        if (searchValue.tabType === SearchTab.Vendors) {
            return (window.location.href = rpAppLink.vendor.detail.base({
                vendorSlug: searchValue.vendor.slug,
                vendorId: searchValue.vendor.id
            }));
        }

        const parsedSearch = parseSearch(location.search);
        const {url, filterValues} = getSearchUrlWithFilters({
            singleRegionFriendlyLink: listFriendlyLink,
            abroadListFriendlyLink: abroadListFriendlyLink,
            multiRegionLink,
            latestQuery,
            searchFormValues: formValues,
            additionalParams: {
                sort: parsedSearch.sort as string
            }
        });

        await saveUserPreferences({filters: filterValues});
        history.push(url);
        onAfterSubmit && onAfterSubmit();
    };
}
import {useHistory, useLocation} from "react-router";

import {parseSearch} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {createOfferLink} from "../../offer/helpers/create_offer_link";
import {OfferListSubType} from "../../offer/list/types/OfferListSubType";
import {useUserPreferences} from "../../user/hooks/use_user_preferences";
import {ILatestQuery} from "../../utils/latest_query";
import {SearchTab} from "../actions/fetch_search_all_action";
import {gtmSearch} from "../analytics/events";
import {ISearchInputValue} from "../components/ISearchInputValue";
import {SearchFormValuesType} from "../types/SearchFormValuesType";
import {getSearchTerm} from "../utils/get_search_term";
import {getSearchUrlWithFilters} from "../utils/get_search_url_with_filters";
import {useSearchGtm} from "./use_search_gtm";

export interface IHookParams {
    multiRegionLink: () => string;
    latestQuery: ILatestQuery;
    listFriendlyLink: (params: {friendlySlug: string; offerListSubFilterSlug?: string}) => string;
    abroadListFriendlyLink: (params: {friendlySlug: string; country: string; abroadRegionSlug?: string}) => string;
    onAfterSubmit?: () => void;
    offerListSubType?: OfferListSubType;
}

// Logic moved from apps/rp/src/common/search/components/Search.tsx
export function useSearchFormSubmit(params: IHookParams) {
    const {multiRegionLink, latestQuery, listFriendlyLink, abroadListFriendlyLink, onAfterSubmit} = params;
    const {gtmLabel, gtmCategory} = useSearchGtm();

    const location = useLocation();
    const history = useHistory();

    const {saveUserPreferences} = useUserPreferences();

    return async (formValues: SearchFormValuesType) => {
        const searchValue = formValues["search"] as ISearchInputValue;
        const searchTerm = getSearchTerm(searchValue);

        gtmSearch(searchTerm, gtmCategory, gtmLabel);

        if (searchValue.tabType === SearchTab.Offers) {
            return (window.location.href = createOfferLink({
                ...searchValue.offer,
                vendor: searchValue.vendor,
                groups: searchValue.offer.groups
            }));
        }

        if (searchValue.tabType === SearchTab.Vendors) {
            return (window.location.href = rpAppLink.vendor.detail.base({
                vendorSlug: searchValue.vendor.slug,
                vendorId: searchValue.vendor.id
            }));
        }

        const parsedSearch = parseSearch(location.search);
        const {url, filterValues} = getSearchUrlWithFilters({
            singleRegionFriendlyLink: listFriendlyLink,
            abroadListFriendlyLink: abroadListFriendlyLink,
            multiRegionLink,
            latestQuery,
            searchFormValues: formValues,
            additionalParams: {
                sort: parsedSearch.sort as string
            }
        });

        await saveUserPreferences({filters: filterValues});
        history.push(url);
        onAfterSubmit && onAfterSubmit();
    };
}
